export const emissionErrors = {
	title: "Emission Errors",
	period: "Period",
	export: "Export Excel",
	drawer: {
		title: "Error History",
		message: "Message",
		type: "Type of error",
		profile: "Tax profile",
		count: "Quantity",
		date: "First day not issued",
		updatedAt: "Last day not issued",
		status: "Status",
		attemptsTitle: "Last emission attempts",
		productsTitle: "Products not issued",
		noAttempts: "No emission attempts found",
		noProducts: "No products not issued found",
		attemptsTable: {
			client: "Client",
			date: "Date",
			error: "Error",
		},
		productsTable: {
			product: "Product",
			count: "Quantity",
		},
	},
	tabs: {
		invoices: "Notes issued",
		products: "Products not issued",
	},
	table: {
		statusLabel: {
			pending: "Pending",
			resolved: "Resolved",
		},
		errorTypeLabel: {
			unknown: "Unknown",
		},
		columns: {
			errorMessage: "Message",
			errorType: "Error types",
			fiscalProfileId: "Fiscal Profile",
			count: "Quantity",
			createdAt: "First day not issued",
			updatedAt: "Last day not issued",
			status: "Status",
		},
	},
};
